/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Invite_Codes_EmptyInputs */

const en_admin_invite_codes_empty = /** @type {(inputs: Admin_Invite_Codes_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No invite codes yet`)
};

const zh_admin_invite_codes_empty = /** @type {(inputs: Admin_Invite_Codes_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无邀请码`)
};

/**
* | output |
* | --- |
* | "No invite codes yet" |
*
* @param {Admin_Invite_Codes_EmptyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_invite_codes_empty = /** @type {((inputs?: Admin_Invite_Codes_EmptyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Invite_Codes_EmptyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_invite_codes_empty(inputs)
	return zh_admin_invite_codes_empty(inputs)
});
export { admin_invite_codes_empty as "admin.invite_codes.empty" }